import { useTranslation } from 'react-i18next'
import { EventFeed } from '@/components/events/EventFeed'

// #122 — the Favourites page is the events feed pinned to the current user's
// favourited events. It reuses EventFeed (and therefore all its filters) and
// only overrides the empty-state copy.
export function FavouritesPage() {
  const { t } = useTranslation('common')
  return (
    <EventFeed
      baseFilters={{ favorite: true }}
      showCategoryTabs={false} // #123 — favourites shows ALL favourites, not split by category
      emptyTitle={t('favourites.emptyTitle')}
      emptyMessage={t('favourites.emptyMessage')}
    />
  )
}
